import { PermissionService, PermissionProvider, HttpService } from '@lk/api'

export const makePermissionService = (http: HttpService, baseUrl: string) =>
  new PermissionService(new PermissionProvider(http, baseUrl))
